const apiUrl = process.env.REACT_APP_API_URL;

export const PostCazaResposta = async (idCaza: string, userId: string, code: string, intentos: number, paso?: number, idConjunt?: number | null) => {
    try {
        const response = await fetch(`${apiUrl}:8061/jutge/caza/${idCaza}/submit`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ userId, code, intentos, paso, idConjunt: idConjunt ?? null })
            });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al enviar la respuesta de caza:', error);
        return null; // Or appropriate error handling
    }
};
